module.exports = "/_next/static/images/DebugYourData-ce19c71b003c31579249b57288439903.webp";